<template>
    <div>
        <v-container>
            <v-card-actions>
                <router-link to="/resources">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo 
            
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" md="6" lg="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <details open>
                        <summary id="cat12">
                            <p><b>E-learning</b></p>
                        </summary>
                        <div>
                            <p>
                                <b>UNODC E-learning </b><a href="https://elearningunodc.org/" target="_blank">https://elearningunodc.org/</a> - Register as a new user; Create a username and password; 
                                Search for relevant courses by utilizing the webpage's search feature. <br><br>

                                Some examples of e-learning courses related to drug dependence prevention, treatment and rehabilitation:
                                <br><br>
                                <b>Brochures:</b>
                                <br><br><ul>
                                    <li>Brochure on UNODC E-learning tool "<a href="https://www.unodc.org/documents/drug-prevention-and-treatment/Treatnet_E-learning_borchure.pdf" target="_blank">Introduction to Treatnet Family</a>"</li>
                                    <li>Brochure on UNODC E-learning tool "<a href="https://www.unodc.org/documents/drug-prevention-and-treatment/ATI_E-learning_brochure.pdf" target="_blank">Treatment and Care as Alternatives to Conviction or Punishment for People in Contact with the Criminal Justice System</a>"</li>
                                    <li>Brochure on UNODC E-learning tool "<a href="https://www.unodc.org/documents/drug-prevention-and-treatment/UNODC_Basic_Counselling_Skills_elearning_brochure_v2.pdf" target="_blank">Basic Counselling Skills</a>"</li>
                                </ul>

                                <b>E-learning courses:</b>
                                <br><br><ul>
                                    <li>
                                        <a href="https://elearningunodc.org/course/view.php?id=287" target="_blank">Basic Counselling Skills:</a>
                                        This course will teach basic counselling skills to health and social service providers. It will help to identify and conduct useful counselling strategies, structure a regular counselling session, understand the importance of clinical supervision, and conduct listening, responding, and teaching strategies to use in basic counselling support. Basic Counselling Skills will help practitioners support those who are under psychological distress and/or mental health conditions in daily settings. Available in: English, Español. Duration: 60 min.
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/view.php?id=707" target="_blank">Treatment and Care as Alternatives to Conviction or Punishment for People with Drug Use Disorders in Contact with the Criminal Justice System:</a>
                                        This course provides an introduction for policymakers, health and justice practitioners and all those interested to learn about options to divert people with drug use disorders in contact with the criminal justice system for offenses of a minor nature to evidence-based treatment and care. Available in: English. Duration: 60 min.
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/view.php?id=380" target="_blank">Treatnet Family:</a>
                                        This course is designed to introduce some elements of Treatnet Family to health and social service providers who work with youths with drug use disorders and their family members. It does not provide any formal training or licensing. Available in: English. Duration: 180 min.
                                    </li>
                                </ul>

                                <b>Some other categories of UNODC e-learning courses available:</b>
                                <br><br><ul>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=65" target="_blank">Airport Interdiction Techniques and Risk Assessment(29)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=9" target="_blank">Anti-Corruption(16)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=50" target="_blank">Basic Training on Charcoal Forensic Examination(2)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=54" target="_blank">Clandestine Laboratories and Precursor Control(11)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=66" target="_blank">Container Profiling and Examination(9)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=13" target="_blank">Controlled Deliveries(9)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=12" target="_blank">Crime Scene Investigation(9)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=42" target="_blank">Curso Introdutório Drogas Ilícitas no Brasil e no contexto internacional(1)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=72" target="_blank">Cybercrime(6)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=18" target="_blank">HIV/AIDS(5)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=19" target="_blank">Human Rights(8)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=20" target="_blank">Implementation of International Drug Policy Commitments(1)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=55" target="_blank">Implementing the United Nations Integrity Curriculum at Universities(3)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=21" target="_blank">Intelligence Analysis(18)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=22" target="_blank">International Narcotics Control Board (INCB)(21)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=24" target="_blank">Introduction and Application of Intelligence(6)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=25" target="_blank">Investigating Drug Organized Crime(8)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=26" target="_blank">Investigative Interviewing(7)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=27" target="_blank">Judicial Ethics(6)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=28" target="_blank">Land Border Interdiction(29)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=30" target="_blank">Money Laundering and Financial Crimes(49)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=32" target="_blank">Organized Crime(9)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=49" target="_blank">Police Reform(3)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=36" target="_blank">Risk Management(8)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=37" target="_blank">Safe Handling and Disposal of Chemicals in Remote, Developing and Non-Secure Environments(3)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=38" target="_blank">Seaport Interdiction Techniques and Risk Assessment(16)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=39" target="_blank">Security Document Examination(8)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=41" target="_blank">Strengthening National Evaluation Capacity(2)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=48" target="_blank">Tomada de Decisão na Audiência de Custódia(1)</a>
                                    </li>
                                    <li>
                                        <a href="https://elearningunodc.org/course/index.php?categoryid=85" target="_blank">Coming soon(31)</a>
                                    </li>
                                </ul>

                                <a href="https://www.who.int/teams/mental-health-and-substance-use/policy-law-rights/qr-e-training" target="_blank">WHO QualityRights e-training on mental health</a>: WHO’s QualityRights initiative aims to improve the quality of care in mental health and related services and to promote the rights of people with psychosocial, intellectual and cognitive disabilities.
                                <br><br>
                                The associated QualityRights e-training, available in 11 languages, covers: taking care of one’s own mental health; supporting friends, family and colleagues with their mental health; tackling stigma, discrimination, abuse and coercion in mental health services; and taking action in support of transformation of mental health services towards a person-centred, rights-based recovery approach.
                            
                                <br><br>

                                <a href="https://humanrights-etrain-qualityrights.coorpacademy.com/signup" target="_blank">Sign up to the QualityRights e-training</a>
                                <br><br>The training has been developed for a wide variety of groups, including people involved in making decisions about mental health care provision, those who provide mental health care and psychosocial support, and people who have received or are receiving support for their mental health.

                                <br><br>
                                <a href="https://cdn.who.int/media/docs/default-source/mental-health/quality-rights/final_ns_cc_who-etraining-flyer-2.pptx?sfvrsn=fddcfa5_7" target="_blank">QualityRights e-training promotional flyer</a>

                                <br><br>WHO QualityRights Flyer: 
                                <a href="https://www.who.int/teams/mental-health-and-substance-use/policy-law-rights/a7aa86e0-8a8e-4cef-a097-da2ff02c14d5" target="_blank">EN </a>-
                                <a href="https://www.who.int/teams/mental-health-and-substance-use/policy-law-rights/956e6fbb-f356-44db-aae7-408e339edf38" target="_blank"> FR</a>-
                                <a href="https://www.who.int/teams/mental-health-and-substance-use/policy-law-rights/f86b8af4-bb4c-4065-b30a-02edef7e171e" target="_blank">ES</a>
                                <br><br>
                                PAHO/WHO Virtual Course on Drug Policy and Public Health (15 hours): 
                                <a href="https://campus.paho.org/en/course/drug-policy_public-health" target="_blank">EN</a> - 
                                <a href="https://campus.paho.org/es/curso/Politicas-Drogas-SaludPublica" target="_blank">ES</a>
                            </p>
                        </div>
                    </details>
                    <a href="" target="_blank"></a>
                    <p class="text-center d-block"></p>
                    <!-- <v-img class="align-end text-white" contain height="320" :src="require('../../assets/Drugs/a1_1.png')"></v-img><br> -->
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [],
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 4,
                    title: 'DRUGS',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li><a href="#cat0" style="text-decoration: none;">4.0. Introduction to the world drug problem</a></li>'+
                            '<li><a href="#cat1" style="text-decoration: none;">4.1. An executive overview of drugs data and trends in Latin America and the Caribbean</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat1_1" style="text-decoration: none;">4.1.1. Drug production and trafficking</a></li>'+
                                    '<li><a href="#cat1_2" style="text-decoration: none;">4.1.2. Drug use and treatment of drug use disorders</a></li>'+
                                    '<li><a href="#cat1_3" style="text-decoration: none;">4.1.3. People in the criminal justice system</a></li>'+
                                    '<li><a href="#cat1_4" style="text-decoration: none;">4.1.4. Young people’s path to harmful substance use is complex </a></li>'+
                                    '<li><a href="#cat1_5" style="text-decoration: none;">4.1.5. Women and girls in prison</a></li>'+
                                    '<li><a href="#cat1_6" style="text-decoration: none;">4.1.6. Drugs, environmental devastation and human rights abuses</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat2" style="text-decoration: none;">4.2. Terminology and information on drugs</a></li>'+
                            '<li><a href="#cat3" style="text-decoration: none;">4.3. International drug control Conventions </a></li>'+
                            '<li><a href="#cat4" style="text-decoration: none;">4.4. UN bodies linked to the international drug control conventions</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat4_1" style="text-decoration: none;">4.4.1. Commission on Narcotic Drugs </a></li>'+
                                    '<li><a href="#cat4_2" style="text-decoration: none;">4.4.2. International Narcotics Control Board</a></li>'+
                                    '<li><a href="#cat4_3" style="text-decoration: none;">4.4.3. United Nations Office on Drugs and Crime</a></li>'+
                                    '<li><a href="#cat4_4" style="text-decoration: none;">4.4.4. World Health Organization</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat5" style="text-decoration: none;">4.5. Other UN and regional actors</a></li>'+
                            '<li><a href="#cat6" style="text-decoration: none;">4.6. UN Common Position on Drugs</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat6_1" style="text-decoration: none;">4.6.1. Background</a></li>'+
                                    '<li><a href="#cat6_2" style="text-decoration: none;">4.6.2. Goals</a></li>'+
                                    '<li><a href="#cat6_3" style="text-decoration: none;">4.6.3. Shared principles</a></li>'+
                                    '<li><a href="#cat6_4" style="text-decoration: none;">4.6.4. Directions for action</a></li>'+
                                    '<li><a href="#cat6_5" style="text-decoration: none;">4.6.5. UN system coordination task team</a></li>'+
                                    '<li><a href="#cat6_6" style="text-decoration: none;">4.6.6. Inter-agency cooperation</a></li>'+
                                    '<li><a href="#cat6_7" style="text-decoration: none;">4.6.7. Tools and resources</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat7" style="text-decoration: none;">4.7. UN Research on Drugs and Crime</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat7_1" style="text-decoration: none;">4.7.1. Drug production</a></li>'+
                                    '<li><a href="#cat7_2" style="text-decoration: none;">4.7.2. Drug trafficking</a></li>'+
                                    '<li><a href="#cat7_3" style="text-decoration: none;">4.7.3. Drug use</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat8" style="text-decoration: none;">4.8. Laboratory and Scientific Services</a></li>'+
                            '<li><a href="#cat9" style="text-decoration: none;">4.9. Alternative Development</a></li>'+
                            '<li><a href="#cat10" style="text-decoration: none;">4.10. Drug Prevention, Treatment and Care</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat10_1" style="text-decoration: none;">4.10.1. Prevention of drug use and other risky behaviours</a></li>'+
                                    '<li><a href="#cat10_2" style="text-decoration: none;">4.10.2. Treatment, health care, social protection and rehabilitation services for people who use drugs and people with drug use disorders; and,</a></li>'+
                                    '<li><a href="#cat10_3" style="text-decoration: none;">4.10.3. Access to controlled drugs for medical purposes, particularly for the management of pain, while preventing diversion and non-medical use</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat11" style="text-decoration: none;">4.11. Law enforcement and judicial cooperation</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat11_1" style="text-decoration: none;">4.11.1. Air</a></li>'+
                                    '<li><a href="#cat11_2" style="text-decoration: none;">4.11.2. Sea</a></li>'+
                                    '<li><a href="#cat11_3" style="text-decoration: none;">4.11.3. Land</a></li>'+
                                    '<li><a href="#cat11_4" style="text-decoration: none;">4.11.4. Other UN responses to drug trafficking</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat12" style="text-decoration: none;">4.12. E-learning</a></li>'+
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: 'The world drug problem - and Member States’ responses to it - is intertwined with an array of social, economic, environmental, health, security, governance and human rights issues.'+
                    '<br><br>The year 2023 marked the midpoint of the work towards achieving the Sustainable Development Goals (SDGs). The world drug problem continues to challenge both the implementation of SDG targets and efforts to promote peace, security and human rights.',
                    description: '',                    
                    images: ['4.png'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarDrug/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarDrug/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte4/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte4/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategoriesDrug/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                return []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }    
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }

    .custom-border {
        border: 2px solid black; /* Grosor y color del borde */
        padding: 16px; /* Espaciado interno */
        border-radius: 4px; /* Bordes ligeramente redondeados */
    }
</style>